/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState } from 'react';
import { Grid, TextField, IconButton, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
/**
 * Event information view is defined here
 * @param {*} param0
 * @returns
 */
const EventInformationView = ({
  e,
  setDeleteSelected,
  setEditSelected,
  setDeleteEventId,
  setEditEvent,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  //
  const open = Boolean(anchorEl);
  //
  const handleClick = (moreClick) => {
    setAnchorEl(moreClick.currentTarget);
  };
  //
  const onEditClick = () => {
    setEditSelected(true);
    setEditEvent({ ...e }, setAnchorEl(null));
  };
  //
  const onDeleteClick = () => {
    setDeleteSelected(true);
    setDeleteEventId(e?.id, setAnchorEl(null));
  };
  //
  return (
    <Grid item container direction="row" key={e?.id}>
      <TextField
        fullWidth
        size="small"
        sx={{
          borderLeft: `5px solid ${e?.fill}`,
          borderTopLeftRadius: 10,
          borderBottomLeftRadius: 10,
          textOverflow: 'ellipsis',
        }}
        id="filled-read-only-input"
        variant="filled"
        label={e?.minorCategory}
        defaultValue={e?.majorCategory}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
          endAdornment: (
            <div>
              <IconButton onClick={handleClick}>
                <MoreHorizIcon />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={() => onEditClick()}>Edit</MenuItem>
                <MenuItem onClick={() => onDeleteClick()}>Delete</MenuItem>
              </Menu>
            </div>
          ),
        }}
      />
    </Grid>
  );
};
//
export default EventInformationView;
